import { Box } from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { Milliseconds } from '@/utils/helpers/Dates'

export const UpdatedAtLabel = ({
  updatedAt,
}: {
  updatedAt: Date | string | number
}) => {
  const [diff, setDiff] = useState(0)

  function calculate() {
    // prettier-ignore
    const since = typeof updatedAt === 'string' || typeof updatedAt === 'number'
      ? new Date(updatedAt)
      : updatedAt;

    const newDiff = Math.floor(
      (new Date().getTime() - since.getTime()) / Milliseconds({ minutes: 1 }),
    )

    setDiff(newDiff)
  }

  useEffect(() => {
    calculate()

    const interval = setInterval(calculate, 10000) // 10 seconds

    return () => clearInterval(interval)
  }, [updatedAt])

  return (
    <Box as="span" color="gray.400" fontSize="xs">
      Atualizado {diff > 0 ? 'a ' + diff + ' min(s)' : 'agora'}
    </Box>
  )
}
